import axios from 'axios';
import { put, call } from 'redux-saga/effects';

// LOCALE
import { t } from '@/locale/i18n';

// CONSTANTS
import { PARTNER_SETTINGS } from '@/constants/api';

// UTILITY
import { getLink } from '@/utility/routes';
import { pushNotification } from '@/utility/snackbar';
import { showErrorNotification } from '@/utility/saga';

// STORE
import { SettingsActions } from '@/store/actions';

const { getSettingsDictionary, updateSettingsDictionary } = SettingsActions;

export function* getSettingsDictionarySaga(action) {
  const { partner_id } = action.payload;

  yield put({ type: getSettingsDictionary.types.START });

  try {
    const res = yield axios.get(getLink(PARTNER_SETTINGS, { partner_id }));

    yield put({
      type: getSettingsDictionary.types.SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: getSettingsDictionary.types.FAIL,
      payload: error,
    });
  }
}

export function* updateSettingsDictionarySaga(action) {
  const { partner_id, data } = action.payload;

  yield put({ type: updateSettingsDictionary.types.START });

  try {
    const res = yield axios.post(getLink(PARTNER_SETTINGS, { partner_id }), data);

    yield put({
      type: updateSettingsDictionary.types.SUCCESS,
      payload: res.data,
    });

    pushNotification(t('notification.partnerSettingsUpdateSuccess'), {
      variant: 'success',
    });
  } catch (error) {
    yield call(showErrorNotification, error);

    yield put({
      type: updateSettingsDictionary.types.FAIL,
    });
  }
}
